"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subject = exports.Submit = exports.Icon = exports.Link = exports.Small = exports.Disabled = exports.Default = void 0;
const react_1 = __importDefault(require("react"));
const Types_1 = require("Types");
const Button_1 = __importDefault(require("./Button"));
exports.default = {
    title: 'Components/ui/Button',
    component: Button_1.default
};
const DefaultTemplate = args => react_1.default.createElement(Button_1.default, Object.assign({}, args));
const defaultArgs = {
    disabled: false,
    overImage: false
};
exports.Default = DefaultTemplate.bind({});
exports.Default.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Default Button' });
exports.Disabled = DefaultTemplate.bind({});
exports.Disabled.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Disabled Button', disabled: true });
exports.Small = DefaultTemplate.bind({});
exports.Small.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Small Button', variant: Types_1.ButtonVariants.SMALL_BUTTON });
exports.Link = DefaultTemplate.bind({});
exports.Link.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Link Button', variant: Types_1.ButtonVariants.LINK_BUTTON });
exports.Icon = DefaultTemplate.bind({});
exports.Icon.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Icon Button', variant: Types_1.ButtonVariants.ICON_BUTTON });
exports.Submit = DefaultTemplate.bind({});
exports.Submit.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Submit', type: Types_1.ButtonTypes.SUBMIT, variant: Types_1.ButtonVariants.SUBMIT_BUTTON });
exports.Subject = DefaultTemplate.bind({});
exports.Subject.args = Object.assign(Object.assign({}, defaultArgs), { children: 'Subject Button', variant: Types_1.ButtonVariants.SUBJECT_BUTTON });
